// deps
import React, { ReactElement, memo } from "react";

// interfaces
import { IPreferredPaymentGroup, IWalletPaymentGroup } from "@payment-ui/interfaces";

// helpers
import { isEmpty } from "@swiggy-private/payment-core";
import { getPaymentGroupDisplayName } from "@payment-ui/helpers/Payment";

// components
import PaymentGroupContainer from "@payment-ui/components/payment-group/components/Container";
import OtherPaymentOffersRenderer from "./components/other-payment-offers-method-renderer";
import PaymentGroupTitle from "@payment-ui/components/payment-group/components/Title";

// hooks
import { useOtherPaymentOffersPaymentGroup } from "./hooks";

//styles
import styles from "./OtherPaymentOffers.scss";

interface IOtherPaymentOffersGroup extends IPreferredPaymentGroup {
    walletGroupData?: IWalletPaymentGroup["paymentData"];
}

function OtherPaymentOffersGroup(props: IOtherPaymentOffersGroup): ReactElement | null {
    const { paymentAmount, user, juspayMeta, paymentGroupBanner, paymentData } = props;

    const { getPaymentActions, getPaymentMethodProps, paymentMethods } = useOtherPaymentOffersPaymentGroup(props);

    if (isEmpty(paymentMethods)) {
        return null;
    }

    return (
        <PaymentGroupContainer>
            <PaymentGroupTitle title={getPaymentGroupDisplayName(paymentData)} />
            <div className={styles.paymentGroupContainer}>
                {paymentMethods.map((paymentMethod) => (
                    <OtherPaymentOffersRenderer
                        key={paymentMethod.displayName}
                        methodData={paymentMethod}
                        getPaymentActions={getPaymentActions}
                        getPaymentMethodProps={getPaymentMethodProps}
                        paymentAmount={paymentAmount}
                        user={user}
                        juspayMeta={juspayMeta}
                        paymentGroupBanner={paymentGroupBanner}
                        walletGroupData={props.walletGroupData}
                    />
                ))}
            </div>
        </PaymentGroupContainer>
    );
}

export default memo(OtherPaymentOffersGroup);
